<template>
  <ul class="upload-progress" v-if="uploads.length">
    <li v-for="upload in uploads" :key="upload.id" :class="'upload-progress-item upload-' + upload.status">
      <div class="upload-progress-header">
        <span class="upload-progress-name" :title="upload.name">{{ upload.name || _('Image') }}</span>
        <span class="upload-progress-status">{{ statusText(upload) }}</span>
        <a href="javascript:;" v-if="upload.status === 'error'" v-on:click="retry(upload.id)" :title="_('Try again')"><i class="fa fa-fw fa-rotate-right"></i></a>
        <a href="javascript:;" v-if="isActive(upload)" v-on:click="cancel(upload.id)" :title="_('Cancel')"><i class="fa fa-fw fa-times"></i></a>
        <a href="javascript:;" v-else-if="upload.status === 'error'" v-on:click="dismiss(upload.id)" :title="_('Remove')"><i class="fa fa-fw fa-times"></i></a>
      </div>
      <div class="progress" v-if="isActive(upload)">
        <div :class="'progress-bar' + (upload.status === 'processing' || upload.status === 'fetching' ? ' progress-bar-striped active' : '')" role="progressbar" :aria-valuenow="barValue(upload)" aria-valuemin="0" aria-valuemax="100" :style="'width: ' + barValue(upload) + '%'"></div>
      </div>
      <div class="text-danger upload-progress-error" v-if="upload.status === 'error' && upload.error">{{ upload.error }}</div>
    </li>
  </ul>
</template>

<script>
import { cancel, dismiss, retry } from '~/lib/uploadqueue'

export default {
  props: {
    uploads: { type: Array, default: () => [] }
  },
  methods: {
    isActive (upload) {
      return ['queued', 'fetching', 'uploading', 'processing'].includes(upload.status)
    },
    barValue (upload) {
      if (upload.status === 'processing' || upload.status === 'fetching') {
        return 100
      }
      return upload.progress || 0
    },
    statusText (upload) {
      switch (upload.status) {
        case 'queued':
          return this._('Waiting')
        case 'fetching':
          return this._('Downloading')
        case 'uploading':
          return upload.progress + ' %'
        case 'processing':
          return this._('Processing')
        case 'done':
          return this._('Done')
        case 'error':
          return this._('Failed')
        case 'canceled':
          return this._('Canceled')
      }
      return ''
    },
    cancel (id) {
      cancel(id)
    },
    retry (id) {
      retry(id)
    },
    dismiss (id) {
      dismiss(id)
    }
  }
}
</script>

<style scoped>
.upload-progress {
  list-style: none;
  padding: 0;
  margin: 0 0 10px;
}
.upload-progress-item {
  margin-bottom: 6px;
}
.upload-progress-header {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
}
.upload-progress-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.upload-progress-status {
  color: #777;
  white-space: nowrap;
}
.upload-progress .progress {
  height: 6px;
  margin: 3px 0 0;
}
.upload-progress-error {
  font-size: 12px;
}
</style>
